{
  "version": 1,
  "asset_id": "88b930a6-c425-45c7-971c-2c3d42657191",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/88b930a6-c425-45c7-971c-2c3d42657191/clip-img_2005.mp4",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/88b930a6-c425-45c7-971c-2c3d42657191/clip-img_2005.mp4",
  "original_filename": "clip-img_2005.mp4",
  "size": 388155,
  "content_type": "video/mp4",
  "created_at": "2026-08-01T22:32:36Z"
}
